import type { LaudoNaTela } from "../api"
import * as Icones from "../componentes/Icones"
import { Column } from "../componentes/TablePrincipal2"
import { dataHora } from "../formato"
import { MAIUSCULA } from "../lib/classes"
import { BlocoEditavel } from "./Campos"
import { EstadoDoPedido, type Pedido } from "./Pedido"
import { BotoesDaLinha, COLUNA_DE_ACOES, TabelaDaFicha, VazioDaFicha } from "./Tabela"

export function BlocoLaudos({ contratoId, pedido }: { contratoId: number; pedido: Pedido<LaudoNaTela[]> }) {
  return (
    <BlocoEditavel
      titulo="Laudos da fiscalização"
      editavel={false}
      motivoSemEdicao="o laudo é gerado ao avaliar uma peça no processo"
      recado={
        "O documento que este sistema PRODUZ e assina. Ele sai daqui para o " +
        "processo, e quem o receber confere a autenticidade pelo código do " +
        "rodapé, sem precisar de conta neste sistema."
      }
      leitura={
        <EstadoDoPedido pedido={pedido} oQue="os laudos">
          {(laudos) => (
            <TabelaDaFicha<LaudoNaTela>
              dados={laudos}
              ordenar={{ assinado_em: (l) => l.assinado_em }}
              vazio={
                <VazioDaFicha
                  titulo="Nenhum laudo assinado neste contrato"
                  descricao="Para gerar um laudo, abra o processo, escolha a peça e registre a avaliação."
                />
              }
            >
              <Column<LaudoNaTela> name="numero" label="Laudo" render={(_v, l) => <span className="tabular-nums">{l.numero}</span>} />
              <Column<LaudoNaTela>
                name="assinado_em"
                label="Assinado em"
                render={(_v, l) => <span className="tabular-nums">{dataHora(l.assinado_em)}</span>}
              />
              <Column<LaudoNaTela>
                name="assinado_por_nome"
                label="Assinado por"
                render={(_v, l) => <span className={MAIUSCULA}>{l.assinado_por_nome ?? "Sem signatário registrado"}</span>}
              />
              <Column<LaudoNaTela>
                name="acoes"
                label="Ações"
                classe={COLUNA_DE_ACOES}
                render={(_v, l) => (
                  <BotoesDaLinha
                    acoes={[
                      {
                        rotulo: "Abrir o laudo",
                        icone: Icones.Abrir,
                        aoClicar: () => window.open(`/api/contratos/${contratoId}/laudos/${l.id}/arquivo`, "_blank", "noreferrer"),
                      },
                    ]}
                  />
                )}
              />
            </TabelaDaFicha>
          )}
        </EstadoDoPedido>
      }
    />
  )
}
